<template lang="pug">
div(:style="{height:height+'px',zIndex:zIndex}")
  div(:class='className', :style="{top:stickyTop+'px',zIndex:zIndex,position:position,width:width,height:height+'px'}")
    slot
      div sticky
</template>

<script>
export default {
  name: 'ElementSticky',
  data () {
    return {
      active: false,
      position: '',
      currentTop: '',
      width: undefined,
      height: 'auto',
      child: null,
      stickyHeight: 0
    }
  },
  props: {
    stickyTop: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: Number,
      default: 10
    },
    className: {
      type: String
    }
  },
  mounted () {
    // this.height = this.$el.getBoundingClientRect().height
    window.addEventListener('scroll', this.handleScroll)
  },
  activated () {
    this.handleScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    sticky () {
      if (this.active) {
        return
      }
      this.position = 'fixed'
      this.active = true
      this.width = this.width + 'px'
    },
    reset () {
      if (!this.active) {
        return
      }
      this.position = ''
      this.width = 'auto'
      this.active = false
    },
    handleScroll () {
      this.width = this.$el.getBoundingClientRect().width
      const offsetTop = this.$el.getBoundingClientRect().top
      if (offsetTop <= this.stickyTop) {
        this.sticky()
        return
      }
      this.reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Sticky/index.vue